import * as $ from 'jquery'

export default function tabContainerDropdownInit() {
  $('.section-tab-container__dropdown .dropdown-item').on('click', function(e) {
    e.preventDefault()

    const $item = $(this)
    const tabTarget = $item.data('tab-target')
    const $tabLink = $(tabTarget)

    // Switch the tab via Bootstrap's tab API
    if ($tabLink.length) {
      $tabLink.tab('show')
    }

    // Update dropdown button text and active state
    const $dropdown = $item.closest('.section-tab-container__dropdown')
    $dropdown.find('.current-refinement').text($item.text().trim())

    $item.closest('.campuses-wrapper').find('.dropdown-item').removeClass('active')
    $item.addClass('active')
  })

  // Keep dropdown in sync when desktop tabs are activated by user interaction.
  // Use setTimeout so the handler ignores programmatic tab changes during page init
  // (e.g. campusInit, weekday toggleVisibleByCss) and the dropdown defaults to the first tab.
  setTimeout(() => {
    $('[data-toggle="tab"]').on('shown.bs.tab', function() {
      syncDropdownToTab($(this))
    })
  }, 0)
}

function syncDropdownToTab($tab: JQuery) {
  const tabId = '#' + $tab.attr('id')
  const $dropdown = $tab.closest('.section-tab-container').find('.section-tab-container__dropdown')

  if ($dropdown.length) {
    const $matchingItem = $dropdown.find(`.dropdown-item[data-tab-target="${tabId}"]`)
    if ($matchingItem.length) {
      $dropdown.find('.dropdown-item').removeClass('active')
      $matchingItem.addClass('active')
      $dropdown.find('.current-refinement').text($matchingItem.text().trim())
    }
  }
}
